import { defaultErrorHandler } from 'api';
import { useEffect, useState } from 'react';
import { EntriesApi } from '../api';
import { EntrySummary } from '../types';

export enum EntryFilter {
  MyEntries = 0,
  MyTeamEntries = 1,
  AllEntries = 2,
}

interface Output {
  entries: EntrySummary[];
  isLoading: boolean;
}

export const useFetchEntries = (
  startDate: Date,
  endDate: Date,
  filter: EntryFilter
): Output => {
  const [entries, setEntries] = useState<EntrySummary[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (startDate && endDate && filter != null) {
      getEntries(startDate, endDate, filter);
    } else {
      setIsLoading(false);
    }
  }, [endDate, startDate, filter]);

  const getEntries = (startDate: Date, endDate: Date, filter: EntryFilter) => {
    EntriesApi.getAll(startDate, endDate, filter)
      .then((fetchedEntries) => {
        setEntries(fetchedEntries);
      })
      .catch((error) => {
        setEntries([]);
        defaultErrorHandler(error);
      })
      .finally(() => setIsLoading(false));
  };

  return { entries, isLoading };
};
